import { Type } from '@sinclair/typebox';
import { BaseTxSchema } from './base-tx.js';
export const LiquidityAddFields = {
    operation: Type.Literal('liquidityAdd'),
    lpMinted: Type.String(),
};
export const LiquidityAddTxSchema = Type.Object({
    ...BaseTxSchema.properties,
    ...LiquidityAddFields,
});
//# sourceMappingURL=liquidity-add-tx.js.map